module.exports = __webpack_public_path__ + "img/content.b133eee.svg";